var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "b-modal",
    {
      attrs: {
        title: "Comentarios Expediente " + _vm.file.numero,
        centered: "",
        "hide-footer": ""
      },
      model: {
        value: _vm.showModal,
        callback: function($$v) {
          _vm.showModal = $$v
        },
        expression: "showModal"
      }
    },
    [
      _c(
        "div",
        { staticStyle: { display: "flex", "flex-direction": "column" } },
        [
          _vm._l(_vm.commentsEd, function(comment) {
            return _c("div", { key: comment.comentarioId }, [
              comment.usuarioId !== _vm.currentUserId
                ? _c(
                    "div",
                    { staticClass: "pill-comment-user" },
                    [
                      _c(
                        "vs-list-item",
                        {
                          attrs: {
                            title: comment.comentario,
                            subtitle: comment.usuarioComentario
                          }
                        },
                        [
                          _c(
                            "template",
                            { slot: "avatar" },
                            [_c("vs-avatar")],
                            1
                          ),
                          _c(
                            "vs-chip",
                            { attrs: { transparent: "", color: "#24c1a0" } },
                            [
                              _c("small", { staticClass: "text-right" }, [
                                _vm._v(_vm._s(comment.creado))
                              ])
                            ]
                          )
                        ],
                        2
                      )
                    ],
                    1
                  )
                : _vm._e(),
              comment.usuarioId === _vm.currentUserId
                ? _c(
                    "div",
                    { staticClass: "pill-comment-me" },
                    [
                      _c(
                        "vs-list-item",
                        {
                          attrs: {
                            title: comment.comentario,
                            subtitle: comment.usuarioComentario
                          }
                        },
                        [
                          _c(
                            "template",
                            { slot: "avatar" },
                            [_c("vs-avatar")],
                            1
                          ),
                          _c(
                            "vs-chip",
                            { attrs: { transparent: "", color: "#24c1a0" } },
                            [
                              _c("small", { staticClass: "text-right" }, [
                                _vm._v(
                                  _vm._s(
                                    _vm._f("dateFormatTime")(
                                      comment.fechaCreacion
                                    )
                                  )
                                )
                              ])
                            ]
                          )
                        ],
                        2
                      )
                    ],
                    1
                  )
                : _vm._e()
            ])
          }),
          _c(
            "div",
            { staticClass: "m-top-20" },
            [
              _c("vs-textarea", {
                attrs: {
                  height: "80px",
                  counter: "500",
                  "counter-danger": _vm.counterDanger
                },
                on: {
                  "update:counterDanger": function($event) {
                    _vm.counterDanger = $event
                  },
                  "update:counter-danger": function($event) {
                    _vm.counterDanger = $event
                  }
                },
                model: {
                  value: _vm.newComment.comment,
                  callback: function($$v) {
                    _vm.$set(_vm.newComment, "comment", $$v)
                  },
                  expression: "newComment.comment"
                }
              }),
              _c(
                "div",
                { staticStyle: { float: "right" } },
                [
                  _c(
                    "vs-button",
                    {
                      attrs: { color: "primary", type: "border" },
                      on: {
                        click: function($event) {
                          return _vm.sendNewComment()
                        }
                      }
                    },
                    [_vm._v(" Enviar ")]
                  )
                ],
                1
              )
            ],
            1
          )
        ],
        2
      )
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }